/**
 * React and utilities
 */
import React from 'react';

/**
 * Using Styled Components for CSS
 */
import styled from 'styled-components';
import { maxWidthForIsMobile } from '../../styles/GlobalStyles';
import ButtonStyled from '../Form/Button';
import StyledCustomSelect from '../Form/CustomSelect';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { theme } from '../../styles/GlobalTheme';

const creditScores = [
  {
    value: '760',
    label: 'Above 760',
  },
  {
    value: '740',
    label: '740-759',
  },
  {
    value: '720',
    label: '720-739',
  },
  {
    value: '700',
    label: '700-719',
  },
  {
    value: '680',
    label: '680-699',
  },
  {
    value: '660',
    label: '<680',
  },
];

export const taxRates = [
  {
    value: 0.4,
    label: '40%',
  },
  {
    value: 0.35,
    label: '35%',
  },

  {
    value: 0.3,
    label: '30% (typical)',
  },
  {
    value: 0.25,
    label: '25%',
  },
  {
    value: 0.2,
    label: '20%',
  },
  {
    value: 0.15,
    label: '15%',
  },
  {
    value: 0,
    label: '0%',
  },
];

/**
 * Financial situation component
 */
const FinancialSituation = ({
  className,
  setStep,
  setData,
  getBestRates,
  data: { creditScore, taxRate },
}) => {
  const handleGetOffer = async () => {
    setStep('loadingOffers');

    getBestRates();
  };

  return (
    <div className={className}>
      <h2>Tell Us About Your Finances</h2>

      <span>What is your credit score?</span>

      <StyledCustomSelect
        defaultValue={'Select your credit score'}
        value={creditScore}
        options={creditScores}
        onChange={({ target }) => setData({ creditScore: target.value })}
      />

      <span>What's your tax bracket? (Combined Federal + State)</span>

      <StyledCustomSelect
        defaultValue={'Select a tax bracket'}
        value={taxRate}
        options={taxRates}
        onChange={({ target }) => setData({ taxRate: target.value })}
      />

      <div id="action-container">
        <ButtonStyled id="back-button" onClick={() => setStep('yourLoan')}>
          Back
        </ButtonStyled>

        <ButtonStyled
          id="call-to-action-button"
          variant="contained"
          disabled={!creditScore || !taxRate}
          onClick={handleGetOffer}
          style={{ background: theme.green8, borderColor: theme.green8 }}
        >
          Save & Next
        </ButtonStyled>
      </div>
    </div>
  );
};

/**
 * The Final Exported Container
 */
const StyledFinancialSituation = styled(FinancialSituation)`
  ${StyledCustomSelect} {
    max-width: 300px;
  }

  .MuiTypography-body1 {
    font-family: var(--font-secondary);
  }

  & > h2 {
    font-size: 2.5em;
    font-weight: 400;
    font-family: Majorant-Medium;
  }

  & > span {
    font-weight: 400;
    font-family: Majorant-Medium;
    display: block;

    margin-top: 32px;
    margin-bottom: 16px;
  }

  #checkbox-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
  }

  #action-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 10vh;
    gap: 10px;

    button {
      height: 43px;
    }

    #back-button {
      width: 159px;
    }

    #call-to-action-button {
      width: 177px;
    }

    @media screen and (max-width: ${maxWidthForIsMobile}) {
      flex-direction: column;

      button,
      #call-to-action-button,
      #back-button {
        width: 100%;
      }

      ${StyledCustomSelect} {
        max-width: 100%;
      }
    }
  }
`;

StyledFinancialSituation.displayName = 'FinancialSituation';

export default StyledFinancialSituation;
